import { CloseOutlined, LocationOnOutlined } from "@mui/icons-material";
import { Box, Typography, Drawer } from "@mui/material";
import { useState } from "react";

export function LocationDrawerBtn() {
  const [openLocation, setOpenLocation] = useState(false);
  return (
    <>
      <Box
        display="flex"
        flex={1}
        alignItems="center"
        justifyContent="center"
        borderRight={1}
        borderColor="divider"
        p={2}
        sx={{
          cursor: "pointer",
          "&:hover": {
            opacity: "0.6",
          },
        }}
        onClick={() => setOpenLocation(true)}
      >
        <LocationOnOutlined color="primary" sx={{ mx: 1 }} />
        <Typography >アクセス</Typography>
      </Box>
      <Drawer
        anchor="right"
        open={openLocation}
        onClose={() => setOpenLocation(false)}
        sx={{
          "& .MuiDrawer-paper": {
            overflowY: "visible",
          },
        }}
      >
        <Box display="flex" flexDirection="column" width={800} p={5}>
          <Box
            position="absolute"
            left="-70px"
            top={15}
            sx={{
              "&:hover": {
                cursor: "pointer",
              },
            }}
            onClick={() => setOpenLocation(false)}
          >
            <CloseOutlined style={{ color: "white", fontSize: "50px" }} />
          </Box>
          <Typography variant="h5" fontWeight="bold">
            アクセス{" "}
          </Typography>

          <Typography variant="body1" my={2}>
            <span style={{ fontWeight: "bold" }}>住所：</span>{" "}
            東京都千代田区紀尾井町1-3 紀尾井テラス3F{" "}
          </Typography>

          <Box
            height="450px"
            width="770px"
            component="img"
            src="/images/store-detail/map1.png"
          />

          <Typography my={2}>公共交通機関でのアクセス</Typography>

          <Typography variant="body1" my={1}>
            東京メトロ丸ノ内線・銀座線 赤坂見附駅  …  7番出口　徒歩3分
          </Typography>

          <Typography variant="body1" my={1}>
            東京メトロ有楽町線・半蔵門線・南北線 永田町駅  …  9b番出口　徒歩4分
          </Typography>
        </Box>
      </Drawer>
    </>
  );
}
